import { ContractsAnalysisItemTypes } from 'store/modules/contract_analysis/types';
import Api from '../api';

export interface ContractValidationPayload {
  modality: string;
  organization: string;
  bidding_number: string;
  bidding_id?: string;
  law?: string;
  edital: File;
  contract: File;
}

export interface ContractValidationsListResponse {
  data: ContractsAnalysisItemTypes[];
  currentPage: number;
  total_entries: number;
}

export const buildContractValidationFormData = (payload: ContractValidationPayload) => {
  const formData = new FormData();

  formData.append('modality', payload.modality);
  formData.append('organization', payload.organization);
  formData.append('bidding_number', payload.bidding_number);

  if (payload.bidding_id) {
    formData.append('bidding_id', payload.bidding_id);
  }

  if (payload.law) {
    formData.append('law', payload.law);
  }

  formData.append('edital', payload.edital);
  formData.append('contract', payload.contract);

  return formData;
};

export const listContractValidations = (biddingId: number) =>
  Api.get<ContractValidationsListResponse>('/contract_validations', {
    params: { bidding_id: biddingId },
  });

export const getContractValidation = (id: string) =>
  Api.get<ContractsAnalysisItemTypes>(`/contract_validations/${id}`);

export const createContractValidation = (payload: ContractValidationPayload) =>
  Api.post<{ id: string }>('/contract_validations', buildContractValidationFormData(payload));
